import { observer } from "mobx-react-lite";
import useNavigateToTenantInMarket from '../../hooks/useNavigateToTenantInMarket';
import useOpenSelectedItem from '../../hooks/useOpenSelectedItem';
import TenantInMarketIcon from '../icons/TenantInMarketIcon';
import styles from '../InfoWithIconAndNavigation.module.css';
import TenantInMarketInfo, { ITenantInMarketInfoProps } from "./TenantInMarketInfo";

function TenantInMarketInfoWithIconAndNavigation({ id, description, landAreaMin, landAreaMax, buildingAreaMin, buildingAreaMax, className, onClick, index }: ITenantInMarketInfoWithIconAndNavigationProps) {
    const navigateToTenantInMarket = useNavigateToTenantInMarket();

    const click = () => {
        onClick && onClick();
        navigateToTenantInMarket(id);
    };

    useOpenSelectedItem(index, click);

    return (
        <div className={[styles.container, className].join(" ")} onClick={click}>
            <TenantInMarketIcon color="#25479A" className={styles.icon} />
            <TenantInMarketInfo
                key={id}
                description={description}
                landAreaMin={landAreaMin}
                landAreaMax={landAreaMax}
                buildingAreaMin={buildingAreaMin}
                buildingAreaMax={buildingAreaMax}
            />
        </div>
    );
}

interface ITenantInMarketInfoWithIconAndNavigationProps extends ITenantInMarketInfoProps {
    id: number;
    index?: number;
}

export default observer(TenantInMarketInfoWithIconAndNavigation);